import * as R from "ramda";
import queryString from "query-string";

export const DEFAULTS = {
  q: "",
  search: "",
  page: 0,
  zipcode: "",
  minradius: "5",
  maxradius: "20",
  unit: "miles",
  term: "",
  keywordsearch: "",

  compare: [],
};

/*
since BE expects any multiselect to be passed with []
we need to specify fields we will need to process special.
this can be avoided in the future by using indexed params
for client side querystring.

e.g.
arg[0]=filterValue&arg[1]=filterValue2

*/
export const fieldTypes = {
  products: "Array",
  projectType: "Array",
  services: "Array",
  specialties: "Array",
  contentTypes: "Array",
  audience: "Array",
  solutions: "Array",
  areasOfInterest: "Array",
  compare: "Array",
  incentive_types: "Array",
  technologies: "Array",
  content_type: "Array",
  planTypeEdc: "Array",
  customerClass: "Array",
  acceptableFees: "Array",
  contentType: "Array",
};

const formatValues = (v, k) =>
  fieldTypes?.[k] === "Array" ? R.flatten([parseValue(v)]) : parseValue(v);

export default function useSearchValues() {
  const { location } = window;
  const { search } = location;
  const searchValues = {
    ...DEFAULTS,
    ...parsedSessionStorage(),
    ...parseSearch(search),
  };

  // remove any values that are the default values
  // (we don't want to clutter the url)
  const removeDefaultValues = R.compose(
    R.fromPairs,
    R.reject((pair) => {
      const [key, value] = pair;
      return DEFAULTS[key] === value;
    }),
    R.toPairs,
  );

  const getParams = removeDefaultValues(search);
  // Set pagination links
  const getLocationFor = (values) => ({
    ...location,
    search: R.compose(
      (s) => `?${s}`,
      (obj) => queryString.stringify(obj),
      removeDefaultValues,
      R.mergeLeft(values),
      parseSearch,
    )(search),
  });

  const apiQueryString = R.compose(
    (s) => (s ? `?${s}` : ""),
    (obj) =>
      queryString.stringify(obj, {
        arrayFormat: "index",
        skipEmptyString: true,
        skipNull: true,
      }),
    parseSearch,
  )(search);

  return { searchValues, getLocationFor, apiQueryString, getParams };
}

function parseValue(value) {
  if (
    !Number.isNaN(Number(value)) &&
    typeof value === "string" &&
    value.trim() !== ""
  ) {
    return String(value);
  }
  if (
    value !== null &&
    typeof value === "string" &&
    (value.toLowerCase() === "true" || value.toLowerCase() === "false")
  ) {
    return value.toLowerCase() === "true";
  }
  return value;
}

/* switch to indexed params */
const parseSearch = (search) =>
  R.compose(
    R.mapObjIndexed((v, k) => formatValues(v, k)),
    (string) =>
      queryString.parse(string, {
        arrayFormat: "index",
        skipEmptyString: true,
        skipNull: true,
      }),
  )(search);
const parsedSessionStorage = () => {
  const store = sessionStorage.getItem("rbv");
  if (store) return JSON.parse(store);
  return {};
};
